<template lang="pug">
    article#pagina
        Banner(:nomePagina="pagina.nome")
        Menu(:menu="menu")
        Formulario
        //- Conteudo(:conteudo="pagina.secoes[0].conteudo", v-if="pagina.secoes")
        BlogFael
</template>

<script>
import Banner from '@components/BannerProuni/BannerProuni.vue'
import Menu from '@sections/Pagina/Menu/Menu.vue'
import Formulario from '@sections/ProuniFormulario/Formulario/Formulario.vue'
import BlogFael from '@components/BlogFael/BlogFael'

import pagina from '@/mixins/pagina'

export default {
    name: "view-pagina",
    mixins: [
        pagina
    ],
    components: {
        Banner,
        Menu,
        Formulario,
        BlogFael
    }
}
</script>

<style lang="stylus" scoped src="./Pagina.styl"></style>